import React, { useContext } from 'react';
import { StyleContext } from 'utils/context/StyleContextProvider';
import Text from 'components/Tailwind/Module/Text';
import { useContentfulInspectorMode } from "@contentful/live-preview/react";

export default function BlogBody({ content, entryId }) {
    const inspectorProps = useContentfulInspectorMode(),
        styles = useContext(StyleContext);

    return (
        <div className={styles.body}
             {...inspectorProps({
                entryId,
                fieldId: 'body',
            })}
        >
            <Text
                data={{
                    body: content,
                    style: 'Left Aligned',
                }}
                useP
            />
        </div>
    );
}
